// Core
import React from "react";

// Styles
import "./styles.scss";

// Assets
import successImg from "../../Assets/Svg/Auth/Celebration.svg";

const SuccessCard = ({ successType, isLast }) => {
  return (
    <div className="successCardWrap">
      <div>
        <img src={successImg} alt="success" />
        <div>Successfully {successType ? "saved" : "submitted"}</div>
        <p className="successMsg">Success! Your responses have been saved. {isLast ? "You can now submit the assessment "  : "You can now proceed to the next section"}.</p>
      </div>
    </div>
  );
};

export default SuccessCard;
